import { css } from '@emotion/react'

export const container = css({
  marginTop: '16px'
})
